import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateSkill } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateSkill() {
  return useMutation({
    mutationFn: async ({ item, skillId }) => {
      const payload = buildPayload(item);
      const response = await updateSkill({ item: payload, skillId });
      return response;
    },
    onSuccess: () => {
      toast.success("Skill Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
